


const body = document.querySelector('body');
if(body.classList.contains('template-collection')){
  document.addEventListener("DOMContentLoaded", function() {
      document.querySelector(".first-grid-changer").addEventListener("click", function() {
        this.classList.add("active");
        document.querySelector(".second-grid-changer").classList.remove("active");
        var elements = document.querySelectorAll("#product-grid.product-grid");
        for (var i = 0; i < elements.length; i++) {
          elements[i].classList.add("grid--1-col-tablet-down");
          elements[i].classList.remove("grid--2-col-tablet-down");
        }
      });

      // Function to remove class .small--one-full when clicking on .second-grid-changer
      document.querySelector(".second-grid-changer").addEventListener("click", function() {
         this.classList.add("active");
        document.querySelector(".first-grid-changer").classList.remove("active");
        var elements = document.querySelectorAll("#product-grid.product-grid");
        for (var i = 0; i < elements.length; i++) {
          elements[i].classList.remove("grid--1-col-tablet-down");
          elements[i].classList.add("grid--2-col-tablet-down");
        }
      });
    });
}


if(body.classList.contains == 'template-product'){
  const headings = document.querySelectorAll('.tabs-heading');
        // Get all the p elements with class "tabs-content"
        const contents = document.querySelectorAll('.tabs-content');

        // Add click event listeners to each h1 element
        headings.forEach((heading) => {
            heading.addEventListener('click', () => {
                // Remove the "active" class from all p elements
                contents.forEach((content) => {
                    content.classList.remove('active');
                });

                // Get the ID of the clicked h1 element
                const targetId = heading.getAttribute('id');

                // Find the corresponding p element with the same ID and add the "active" class
                const targetContent = document.getElementById(targetId);
                targetContent.classList.add('active');
            });
        });
}




